import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/types/database';
import { env } from './env';

/**
 * Single browser client. The publishable (anon) key is public by design — every
 * table is protected by row level security, and the secret key never leaves the
 * Edge Function runtime.
 */
export const supabase = createClient<Database>(
  env?.VITE_SUPABASE_URL ?? 'http://127.0.0.1:54321',
  env?.supabaseKey ?? 'anon-key-not-configured',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
    },
    global: {
      headers: { 'x-application-name': 'nikita-kering-shop' },
    },
    db: { schema: 'public' },
  },
);
